import { State } from './selector';

/**
 * Update flags for Overlay container
 */
export const getUpdateFlags = (newState: State, oldState: State) => {
    const { isOpen, isLoaded, activeContent, isLoading } = newState;

    return {
        loading: isLoading !== oldState.isLoading,
        visibility: isOpen !== oldState.isOpen,
        content: activeContent !== oldState.activeContent,
        loaded: isLoaded && isLoaded !== oldState.isLoaded,
    };
};
